import { useQueryClient, useMutation } from 'react-query';
import { useAxiosInstance } from '../common';
import { FileNode } from '../../types/DataDelivery';

const useCleanConfigSapFlows = () => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (configId: string) => {
      const response = await axios.post<FileNode>('dataproject/clearConfigSapFlows', null, {
        params: {
          configId,
        },
      });
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['sapGroups'], { refetchInactive: true });
      },
    }
  );
};

export default useCleanConfigSapFlows;
